import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "./ui/ErrorFallback";

import { Analytics } from "@vercel/analytics/next";

import { FangoWrapper } from "./scenes/FangoWrapper";
import { SessionPlayerProvider } from "./SessionPlayerContext";

import "./assets/styles/main.css";
import "./assets/styles/cursors.css";

createRoot(document.getElementById("react-root")!).render(
  <StrictMode>
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <SessionPlayerProvider>
        <FangoWrapper />
        <Analytics />
      </SessionPlayerProvider>
    </ErrorBoundary>
  </StrictMode>
);
